import { render, staticRenderFns } from "./sence.vue?vue&type=template&id=577d75ec&scoped=true&"
import script from "./sence.vue?vue&type=script&lang=js&"
export * from "./sence.vue?vue&type=script&lang=js&"
import style0 from "./sence.vue?vue&type=style&index=0&id=577d75ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577d75ec",
  null
  
)

export default component.exports